import { AxiosPromise } from 'axios';
import request from '../network';

export function overviewByCrmApi(params: any) {
  return request({
    url: '/member/royalcanin/admin/statistics/dashboard/overview',
    method: 'GET',
    params,
  });
}

export function desktopTrendApi(params: any) {
  return request({
    url: '/member/royalcanin/admin/statistics/dashboard/desktopTrend',
    method: 'GET',
    params,
  });
}

export function pageTrendApi(params: any) {
  return request({
    url: '/member/royalcanin/admin/statistics/dashboard/pageTrend',
    method: 'GET',
    params,
  });
}

export function functionRankingApi(params: any) {
  return request({
    url: '/member/royalcanin/admin/statistics/dashboard/functionRanking',
    method: 'GET',
    params,
  });
}

export function adClicksApi(params: any) {
  return request({
    url: '/member/royalcanin/admin/statistics/dashboard/adClicks',
    method: 'GET',
    params,
  });
}

export function clickTrendApi(params: any) {
  return request({
    url: '/member/royalcanin/admin/statistics/dashboard/clickTrend',
    method: 'GET',
    params,
  });
}
